import { clsx } from "clsx";

export default function DrawForm({ className }: { className?: string }) {
  return (
    <svg
      className={clsx("", className)}
      viewBox="0 0 243 55"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g className="mix-blend-multiply">
        <g clipPath="url(#clip0_739_1349)">
          <path
            d="M236.578 16.4168C236.022 16.8369 226.958 16.7452 225.391 16.8579C224.323 17.0127 225.879 18.701 226.19 19.0823C228.927 21.4716 228.474 24.9971 229.291 27.7084C230.116 28.7825 231.578 28.3587 232.259 28.8801C234.78 31.2894 232.36 34.493 237.602 34.6721C241.326 36.8527 240.354 41.4125 240.993 44.1259C242.135 45.7711 243.744 49.2584 242.62 50.9089C197.555 51.5037 147.974 49.9081 104.72 52.0182C104.616 52.0926 102.644 51.6461 102.129 51.6488C101.126 51.6542 99.2858 51.989 97.8169 51.9966C96.3437 52.0041 94.0015 51.6989 92.7698 51.7841C91.3412 51.8828 90.2466 52.5838 88.4185 51.7874L88.0844 52.2015C86.5507 51.5798 83.8282 53.1581 83.0222 52.0521C82.689 51.9783 81.8738 52.3724 81.5987 52.3891C80.8726 52.4344 78.9132 52.4991 78.9855 52.0176C59.5132 53.7906 37.9257 52.7289 17.7163 54.153C16.5671 54.2285 13.1765 54.4479 12.3546 53.9632C11.3618 53.3776 11.8994 52.3099 11.7084 51.7928C10.963 49.7668 9.47641 47.7307 8.58965 45.811C7.9065 44.3319 7.95866 42.7056 7.14847 41.2378C8.45588 40.8565 9.53951 41.268 10.6652 41.2464C26.599 40.073 25.5086 42.2418 20.7274 32.1991C18.492 31.9495 7.05592 33.2415 5.46078 31.86C4.63376 31.2156 3.12359 26.7124 2.59944 25.4991C1.56041 23.6048 -0.153359 21.1071 0.760316 19.0267C1.45272 19.2241 0.879784 19.7827 2.07278 19.2775C2.81819 18.962 2.43455 19.2678 3.43908 19.3508C5.33879 19.5083 9.5496 19.2791 11.5721 19.1178C13.4045 18.9717 15.3741 18.4972 17.2435 18.3759C14.5412 14.7296 10.9824 8.59037 11.5974 4.30508C82.5654 -4.19919 158.386 4.99853 230.374 0.0429688C235.322 2.70463 236.431 12.3159 236.578 16.4168ZM66.0258 25.4975L64.6848 25.2802V25.7094L66.0267 25.7084V25.4975H66.0258ZM29.3543 49.2174C28.5963 49.2034 28.6636 49.1618 28.6846 49.6466L29.3543 49.2174Z"
            fill="#34EEFF"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_739_1349">
          <rect
            width="242.5"
            height="54.2259"
            fill="white"
            transform="translate(0.5 0.0429688)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
